import {
  initPostcodeChecker,
} from './woocommerceCheckout';

export default {
  init() {
    initPostcodeChecker();
  },
};
